<script setup lang="ts">
type Variant = 'card' | 'modal'

withDefaults(defineProps<{
  title: string
  isLoading?: boolean
  isSpinning?: boolean
  error?: unknown | undefined
  variant?: Variant
  withCloseButton?: boolean
  centerTitle?: boolean
}>(), { variant: 'card', withCloseButton: undefined })
defineEmits<{ (e: 'close'): void }>()
</script>

<template>
  <ClientOnly>
    <n-skeleton v-if="isLoading" class="rounded" :class="$attrs.class" height="30vh" width="100%" :sharp="false" />
    <n-card
      v-else
      class="bg-white w-full"
      :class="$attrs.class"
      :header-class="`${variant === 'modal' ? '!py-4' : ''} ${centerTitle ? '!flex-col' : ''}`"
      :segmented="true"
    >
      <template #header>
        <h2 class="text-hos-blue font-semibold" :class="{ 'text-2xl': variant === 'card', 'text-xl': variant === 'modal' }">
          {{ title }}
        </h2>
      </template>

      <template #header-extra>
        <div class="w-full md:w-fit flex flex-col-reverse md:flex-col">
          <slot name="headerExtra" />
        </div>
      </template>

      <div v-if="withCloseButton || (variant === 'modal' && withCloseButton !== false)" class="absolute top-4 right-4">
        <n-button
          type="primary"
          tertiary
          class="size-8"
          @click="$emit('close')"
        >
          <template #icon>
            <Icon name="material-symbols:close-rounded" />
          </template>
        </n-button>
      </div>

      <n-spin :show="isSpinning">
        <template v-if="error">
          {{ $t('customerModule.error.text', { error: error || 'N/A' }) }}
        </template>
        <template v-else>
          <slot />
        </template>
      </n-spin>
    </n-card>

    <template #fallback>
      <n-skeleton class="rounded" :class="$attrs.class" height="30vh" width="100%" :sharp="false" />
    </template>
  </ClientOnly>
</template>

<style scoped>
:deep(.n-card-header) {
  @apply flex-col gap-y-2 md:flex-row
}
:deep(.n-card-header__extra) {
  @apply w-full md:w-fit
}
</style>
